import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setUIProperty(state, action) {
      const { name } = action.payload;
      const { value } = action.payload;
      state[name] = value;
    },
    setUIData(state, action) {
      const { name } = action.payload;
      const { value } = action.payload;
      state[name] = { ...state[name], ...value };
      
      // This code resets the object if it has no properties 
      Object.keys(state[name]).forEach(
        (key, index) => {
          // console.log(state[name][key]);
          // console.log(state[name]);
          // console.log(typeof(state[name][key]));
          // debugger;
          if(name === "selectedLineItems" && state[name][key] && state[name][key].length === 0  && typeof(state[name][key]) === "object"){
            debugger;
            delete state[name][key];
          }
        }
      );
      //console.log(state[name]);
    },
  },
});

export const { setUIProperty, setUIData } = uiSlice.actions;
export const getUIProperty = (state, name) => state.ui[name];
export const getUIData = (state, name) => state.ui[name] || {};

export default uiSlice.reducer;
